// Runtime Configuration Loader
// Fetches /config.json from the app's origin at runtime
// This allows configuration to be changed without rebuilding the app

let runtimeConfig = null;

// The app is deployed under the "/camcopilot" base path (see "homepage" in
// package.json and "service_path" in .pipeline/config.yaml). The config file
// lives at <origin>/camcopilot/config.json. We use this fixed base path rather
// than deriving it from window.location.pathname, because the app may be
// served at the root path ("/") in some environments, which would otherwise
// make the loader request the wrong URL (e.g. /config.json instead of
// /camcopilot/config.json).
const CONFIG_BASE_PATH = '/camcopilot';

export const loadRuntimeConfig = async () => {
  if (runtimeConfig) return runtimeConfig;
  
  try {
    const configPath = `${CONFIG_BASE_PATH}/config.json`;
    const response = await fetch(configPath);
    if (!response.ok) throw new Error(`Failed to load config: ${response.status}`);
    
    runtimeConfig = await response.json();
    console.log('[Config] Runtime config loaded:', runtimeConfig);
    return runtimeConfig;
  } catch (error) {
    console.error('Failed to load runtime config:', error);
    runtimeConfig = {};
    return runtimeConfig;
  }
};

export const getConfig = () => runtimeConfig || {};
